import React from 'react';
import nextArrowIcon from '@assets/icon/next_arrow_icon.png';
import { ITotalSalesItem, TRANSACTION } from '@dataTypes/totalSalesTypes';
import { formatPayMethodLabel } from '@utils/mileageDisplay';
import { format } from 'date-fns';
import { Button } from 'react-bootstrap';
import { AUTH } from '@dataTypes/authTypes';
import Cookies from 'js-cookie';

interface TotalSalesListsProps {
  showDetailPayment: (id: number) => void | null;
  item: ITotalSalesItem;
  cancelBtn: React.ReactNode | null;
  showMileage?: boolean;
}

const TotalSalesLists = ({
  showDetailPayment,
  item,
  cancelBtn,
  showMileage = true,
}: TotalSalesListsProps) => {
  const authority = Cookies.get('smartlab_authority');
  const formatTransactionDate = (transactionDate: string) => {
    const datePart = transactionDate.slice(0, 6); // "240601"
    const timePart = transactionDate.slice(6); // "000002"

    // 날짜 포맷팅
    const year = datePart.slice(0, 2); // "24"
    const month = datePart.slice(2, 4); // "06"
    const day = datePart.slice(4, 6); // "01"
    const formattedDate = `${year}-${month}-${day}`; // "24-06-01"

    // 시간 포맷팅
    const hours = timePart.slice(0, 2); // "00"
    const minutes = timePart.slice(2, 4); // "00"
    const seconds = timePart.slice(4, 6); // "02"
    const formattedTime = `${hours}:${minutes}:${seconds}`; // "00:00:02"

    return [formattedDate, formattedTime];
  };

  const [formattedDate, formattedTime] = formatTransactionDate(item.transactionDate);

  const addCommas = (number: number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  return (
    <li className="sales_list" onClick={() => showDetailPayment(item.id)}>
      <section className="top_section">
        <div className="sales_date">
          <div className="date_wrapper">
            <span className="date">{formattedDate}</span>
            <span className="time">{formattedTime}</span>
          </div>
          <div className="device_alias_wrapper">
            <span className="device_alias">{item.deviceAlias}</span>
          </div>
        </div>
        <div className={`pay_type ${item.transactionStatus === TRANSACTION.C ? 'cancel' : ''}`}>
          {formatPayMethodLabel(showMileage, item.method, item.transactionStatus)}
        </div>
      </section>

      <section className="bottom_section">
        <div className="money_wrapper">
          <div className="price">
            <div className="text">금액</div>
            <div className="price_money">{addCommas(item.amount)}</div>
          </div>
          <div className="vat">
            <div className="text">부가세</div>
            <div className="vat_money">{addCommas(item.tax)}</div>
          </div>

          {/* <div className="charge">
            <div className="text">수수료</div>
            <div className="charge_money">{addCommas(item.serviceCharge)}</div>
          </div> */}
        </div>

        {!cancelBtn ? (
          <div className="arrow_icon_wrapper">
            <img src={nextArrowIcon} className="detail_arrow_icon" alt="상세보기 버튼" />
          </div>
        ) : (
          cancelBtn
        )}
      </section>
    </li>
  );
};

export default TotalSalesLists;
